<template>
  <div id="promises" data-type="layout" data-header="green" class="span-full bgwhite black"
    v-bind:style="{ 
      transformStyle: (isDialogActive ? 'flat' : 'preserve-3d')
    }">
    
    <div class="full-inner">
      <h2 class="green">{{page.title}}</h2>
      <h3 class="mt3" v-html="page.content"></h3>
      <a href="#" v-on:click.prevent="openDialog" class="btn btn-green mt3">{{page.callToAction}}</a>
    </div>

    <div class="span-dialogs-wrapper" v-if="isDialogActive">        
      
      <transition name="simple-fade">
        <div class="span-dialogs span-full" v-if="isDialogListActive">
          <div class="full-inner">
            <div class="item-dialog item-dialog-single pt3 pb3 content-500" v-bind:class="'bg'+activeDialog.background_color">
              <h3 class="uppercase pl3 pr3 pb1">
                <span class="content">{{activeDialog.content}}</span>
              </h3>
              <a href="#" v-on:click.prevent="showNext" class="btn btn-white white mt1">{{activeDialog.trigger}}</a>
            </div>
          </div>
        </div>
      </transition>

      <transition name="simple-fade-confirmation">
        <div v-bind:key="'confirmation'" class="span-confirmation span-full" v-if="isConfirmationActive">
          <div class="full-inner">
            <div class="item-dialog item-dialog-confirmation pt3 pb3 content-750 bgblue">
              <h2>{{confirmation.title}}</h2>
              <div class="entry-content pl3 pr3 pt2 pl5 pr5">
                <p class="title-font">{{confirmation.content}}</p>
                <a href="#" v-on:click.prevent="closeConfirmation" class="btn btn-white mt2">{{confirmation.close}}</a>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <a href="#" data-index="1" class="read-more green">
      <span class="arrow-down"></span>
    </a>
  </div>
</template>
<script>
  export default {
    name: 'solutions-advise',
    data(){
      return {
        isDialogActive: false,
        isDialogListActive: false,
        isConfirmationActive: false,
        activeIndex: 0,
        page: {
          title: '',
          content: '',
          callToAction: ''
        },
        confirmation: {
          title: '',
          content: '',
          close: ''
        },
        dialogs: []
      }
    },
    computed: {
      activeDialog(){
        return this.dialogs[this.activeIndex]
      }
    },
    methods: {
      openDialog(){
        this.isDialogActive = true
        this.$nextTick(()=>{
          this.isDialogListActive = true
        })
      },
      closeDialog(){
        this.isDialogListActive = false
        setTimeout( () => {
          this.isDialogActive = false
        },300)
      },
      closeConfirmation(){
        this.isConfirmationActive = false
        setTimeout(()=>{
          this.isDialogActive = false
          this.activeIndex = 0
        },600)
      },
      showNext(){
        if( parseInt(this.activeIndex) + 1 < this.dialogs.length ){
            this.isDialogListActive = false
            setTimeout(()=>{
              this.activeIndex += 1
            },400)
            setTimeout(()=>{
              this.isDialogListActive = true
            },500)
        } else {
          this.isDialogListActive = false
          setTimeout(()=>{
            this.isConfirmationActive = true
          },1000)
        }
      },
      getUrl(){
        if( localStorage.getItem('language') === 'en' ){
          return process.env.site.url + '/wp-json/wp/v2/pages?slug=solutions-promises'
        } else {
          return process.env.site.url + '/wp-json/wp/v2/pages?slug=soluciones-promesas&lang=es'
        }
      },
      loadContent(){
        var getUrl = this.getUrl()
        this.axios.get(this.getUrl()).then((response) => {
          
          this.activeDialog = this.dialogs[this.index]
          // document.body.addEventListener('keyup', (e) => {
          //   if(e.keyCode === 27){
          //     this.closeDialog()
          //   }
          // })

          var page = response.data[0].acf

          this.page.title = page.title
          this.page.content = page.description
          this.page.callToAction = page.call_to_action
          this.dialogs = page.promises
          this.confirmation.title = page.confirmation_title
          this.confirmation.content = page.confirmation_text
          this.confirmation.close = page.confirmation_close

        })
      }
    },
    watch: {
      '$route': 'loadContent',
      isDialogActive(){
        if(this.isDialogActive){
          document.body.classList.add('dialog-active')
        } else {
          document.body.classList.remove('dialog-active')
        }
      }
    },
    mounted(){
      this.$nextTick( () => {
        this.loadContent()
      })
    }
  }
</script>
<style lang="stylus">
  body.dialog-active
    overflow: hidden
    .header-wrapper
      display: none
  
  .span-dialogs-wrapper
    transform-style flat !important
    position fixed
    z-index 500
    top 0
    left 0
    width 100%
    height 100%
    background rgba(255,255,250,0.8)
</style>


// WEBPACK FOOTER //
// Solutions-promises.vue?1440a40c